import { createContext } from 'react';

// The V3 route table (GET v3/routes): every route and the PowerShell command that makes the same call. The "PowerShell" button is made
// from it. RouteTableProvider fills it; it is a separate file so a component that only reads it does not pull in the API client.
export const RouteTableContext = createContext({ routes: [], loaded: false });
